import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Evaluation } from '../../types/models';

interface EvaluationState {
  evaluations: Evaluation[];
  currentEvaluation: Evaluation | null;
  loading: boolean;
  error: string | null;
  generating: boolean;
}

const initialState: EvaluationState = {
  evaluations: [],
  currentEvaluation: null,
  loading: false,
  error: null,
  generating: false,
};

export const evaluationSlice = createSlice({
  name: 'evaluation',
  initialState,
  reducers: {
    fetchEvaluationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchEvaluationsSuccess: (state, action: PayloadAction<Evaluation[]>) => {
      state.evaluations = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchEvaluationSuccess: (state, action: PayloadAction<Evaluation>) => {
      state.currentEvaluation = action.payload;
      state.loading = false;
      state.error = null;
    },
    fetchEvaluationFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    generateEvaluationStart: (state) => {
      state.generating = true;
      state.error = null;
    },
    generateEvaluationSuccess: (state, action: PayloadAction<Evaluation>) => {
      state.currentEvaluation = action.payload;
      state.evaluations.push(action.payload);
      state.generating = false;
      state.error = null;
    },
    generateEvaluationFailure: (state, action: PayloadAction<string>) => {
      state.generating = false;
      state.error = action.payload;
    },
    clearEvaluationError: (state) => {
      state.error = null;
    },
    clearCurrentEvaluation: (state) => {
      state.currentEvaluation = null;
    },
  },
});

export const {
  fetchEvaluationsStart,
  fetchEvaluationsSuccess,
  fetchEvaluationSuccess,
  fetchEvaluationFailure,
  generateEvaluationStart,
  generateEvaluationSuccess,
  generateEvaluationFailure,
  clearEvaluationError,
  clearCurrentEvaluation,
} = evaluationSlice.actions;

export default evaluationSlice.reducer;
